export default {"src":"/_next/static/media/tgch.2aba6cab.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};